import React from 'react'
import { StyledSkeleton } from './styled'

interface Props {
  width?: string
  height?: string
}

const Skeleton = (props: Props) => {
  const { width = 'auto', height = 'auto' } = props
  return <StyledSkeleton style={{ width: width, height: height }}></StyledSkeleton>
}

export default Skeleton
